import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { type AppDispatch, type AppState } from "../../store";
import { deleteInsurance, getInsurances } from "./modules/actions";

const mapStateToProps = (state: AppState) => ({
  state: {
    insurances: state.insuranceReducer.insurances,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators(
    {
      getInsurances,
      deleteInsurance,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
